import { render, staticRenderFns } from "./TheСustomTablePage.vue?vue&type=template&id=5746d225"
import script from "./TheСustomTablePage.vue?vue&type=script&lang=js"
export * from "./TheСustomTablePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports